import React from 'react';
import { Checkbox } from '../../Checkbox';
const CheckboxWrapper = React.forwardRef(({ handleOnKeyDown, label, name, isDisabled, onChange, isChecked, className, }, ref) => {
    return (React.createElement(Checkbox, { label: label, name: name, isDisabled: isDisabled, onChange: onChange, isChecked: isChecked, onKeyDown: handleOnKeyDown, className: className, ref: ref }));
});
export { CheckboxWrapper };
//# sourceMappingURL=CheckboxWrapper.js.map